var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"youkexianxiaxingweifenxi"},[_c('IconList',{attrs:{"list":_vm.list,"marginBottom":0.3}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }